import React from "react";

const Centered: React.FC = ({ children }) => (
  <div className="centered">
    <div className="centered-content">{children}</div>
  </div>
);
export default Centered;
